import React from "react";

export default function ObjectiveCard({ icon, title, description }) {
  return (
    <div className="p-4 md:w-1/3 w-full" data-aos="fade-up">
      <div
        className="flex flex-col items-center text-center p-8 rounded-2xl bg-gray-50 shadow-lg 
                   hover:shadow-2xl transform transition-all duration-500 hover:-translate-y-4 
                   hover:bg-gradient-to-b hover:from-green-50 hover:to-white cursor-pointer 
                   h-full"
      >
        {/* Animated Icon */}
        <div className="w-14 h-14 mb-5 flex items-center justify-center rounded-full 
                        bg-gradient-to-r from-primary to-secondary text-white text-2xl 
                        shadow-lg transform transition-transform duration-500 
                        hover:scale-110">
          {icon}
        </div>

        {/* Title */}
        <h3 className="text-xl font-bold mb-3 text-gray-900">{title}</h3>

        {/* Description */}
        <p className="text-gray-600 text-sm fonnt-light leading-relaxed flex-grow">
          {description}
        </p>
      </div>
    </div>
  );
}
